/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AccessGroup } from '../models/AccessGroup';
import type { CreateUserDto } from '../models/CreateUserDto';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { PasswordUpdateDto } from '../models/PasswordUpdateDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { User } from '../models/User';
import type { UserAdminViewModel } from '../models/UserAdminViewModel';
import type { UserDto } from '../models/UserDto';
import type { UserStatusDto } from '../models/UserStatusDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UserService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns UserAdminViewModel
     * @throws ApiError
     */
    public userGetUserAdminDetails(): Observable<Array<UserAdminViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/users/admindetails',
        });
    }
    /**
     * @param id
     * @returns User
     * @throws ApiError
     */
    public userGet(
        id: number,
    ): Observable<User> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/users/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param encodedEmail
     * @returns UserDto
     * @throws ApiError
     */
    public userGetUserByEmail(
        encodedEmail: string,
    ): Observable<UserDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/users/useremail/{encodedEmail}',
            path: {
                'encodedEmail': encodedEmail,
            },
        });
    }
    /**
     * @returns UserAdminViewModel
     * @throws ApiError
     */
    public userGetUserAccountDataByEmailClaim(): Observable<UserAdminViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/users/me/account',
        });
    }
    /**
     * @returns string
     * @throws ApiError
     */
    public userSetLastLoginTime(): Observable<string> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/users/me/lastlogintime',
        });
    }
    /**
     * @returns AccessGroup
     * @throws ApiError
     */
    public userGetUserGroupsByEmailClaim(): Observable<Array<AccessGroup>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/users/me/groups',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public userCreate(
        requestBody: CreateUserDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public userUpdate(
        requestBody: UpdateUserDto,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public userSetUserStatus(
        requestBody: UserStatusDto,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/users/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public userUpdatePassword(
        requestBody: PasswordUpdateDto,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/users/password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param base64EncodedEmail
     * @param justification
     * @returns number
     * @throws ApiError
     */
    public userResetPassword(
        base64EncodedEmail?: string | null,
        justification?: string | null,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/users/password/reset',
            query: {
                'base64EncodedEmail': base64EncodedEmail,
                'justification': justification,
            },
        });
    }
    /**
     * @param statusId
     * @returns number
     * @throws ApiError
     */
    public userGetLoggedUserSitesByStatusId(
        statusId: number,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/users/me/sites/status/{statusId}/count',
            path: {
                'statusId': statusId,
            },
        });
    }
}
